import { ICompanyStyle } from './CompanyStyle.interface';

export const initialState: ICompanyStyle = {
  TosUrl: '',
  logo: '',
  backgroundImage: '',
  backgroundStyles: '',
  responsiveStyles: ''
};
